<div class="custom-paginator-outer-container" role="group">
  <div class="custom-paginator-container">
    <div class="custom-paginator-page-size">
      <div class="custom-paginator-page-size-label" [id]="pageSizeLabelId">Items per page:</div>

      <div class="custom-paginator-page-size-select" *ngIf="displayedPageSizeOptions.length > 1">
        <select [attr.aria-labelledby]="pageSizeLabelId" [ngModel]="pageSize" (ngModelChange)="changePageSize($event)">
          <option *ngFor="let pageSizeOption of displayedPageSizeOptions" [ngValue]="pageSizeOption">{{ pageSizeOption }}</option>
        </select>
        <span class="custom-paginator-select-arrow" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false">
            <path d="M7 10l5 5 5-5z"/>
          </svg>
        </span>
      </div>

      <div class="custom-paginator-page-size-value" *ngIf="displayedPageSizeOptions.length <= 1">{{ pageSize }}</div>
    </div>

    <div class="custom-paginator-range-actions">
      <div class="custom-paginator-range-label" aria-live="polite">{{ rangeLabel }}</div>

      <button type="button" class="custom-paginator-navigation-previous"
              (click)="previousPage()"
              [disabled]="!hasPreviousPage()"
              aria-label="Previous page"
              [synxTooltip]="hasPreviousPage() ? 'Previous page' : ''" synxTooltipCaret="below">
        <svg class="custom-paginator-icon" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
        </svg>
      </button>
      <button type="button" class="custom-paginator-navigation-next"
              (click)="nextPage()"
              [disabled]="!hasNextPage()"
              aria-label="Next page"
              [synxTooltip]="hasNextPage() ? 'Next page' : ''" synxTooltipCaret="below">
        <svg class="custom-paginator-icon" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
          <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
        </svg>
      </button>
    </div>
  </div>
</div>
